import React from 'react'
import { NotFoundError } from '@features/errors/NotFoundError'
import { getPlace, initPlace, getGift } from '@app-core/place/actions'
import { getTopicList } from '@app-core/posts/actions'
import PlaceContainer from './PlaceContainer'
import { compose, withBeacon, withReloadPageAfterLogin } from '@hocs'
import { withRNApp } from '@libs/RNApp'

function Place({ hasError, ...props }) {
  if (hasError) {
    return <NotFoundError isApp={props.isApp} />
  }
  return <PlaceContainer {...props} />
}

Place.getInitialProps = async ({ res, req, query, store, namespacesRequired }) => {
  const { placeId: queryPlaceId, via = 'direct' } = query
  const hideNavbar = Boolean(req?.headers['rn-webview-with-header'])
  const props = {
    placeId: queryPlaceId,
    namespacesRequired,
    via,
    hideNavbar,
    hasError: false,
    queryPlaceId,
  }
  try {
    store.dispatch(initPlace(queryPlaceId))
    const placeId = store.getState().place.get('placeId')
    let place = store.getState().place.getIn(['places', placeId])
    if (!place) {
      await store.dispatch(getPlace({ placeId }))
      place = store.getState().place.getIn(['places', placeId])
    }
    if (!place) {
      throw new Error(`Place ID =${placeId} does not exist`)
    }
    await Promise.all([
      store.dispatch(getTopicList({ postId: placeId })),
      store.dispatch(getGift({ placeId })),
    ])
  } catch (error) {
    props.hasError = true
    console.warn(error)
    res.status(404)
  }
  return props
}

export default compose(withRNApp, withReloadPageAfterLogin, withBeacon)(Place)
